import * as customizationDe from './de.json';
import * as customizationEn from './en.json';
import * as customizationEs from './es.json';
import * as customizationFr from './fr.json';
import * as customizationIt from './it.json';

export const translationsCustomization = new Map([
  ['de', { ...customizationDe }],
  ['en', { ...customizationEn }],
  ['es', { ...customizationEs }],
  ['fr', { ...customizationFr }],
  ['it', { ...customizationIt }],
]);
